import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";

const usePatchDoctorStatic = ({
  getAllDoctorStatic = () => {},
  onCloseModal = () => {},
}) => {
  const [isDoctorStaticPatching, setIsDoctorStaticPatching] = useState(false);

  const onPatchDoctorStatic = async (docId, payload, isFormData = false) => {
    setIsDoctorStaticPatching(true);
    const token = localStorage.getItem("authToken");
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "hgs",
      };

      // Only set Content-Type if not FormData (axios will set it automatically for FormData)
      if (!isFormData) {
        headers["Content-Type"] = "application/json";
      }

      let patchData = payload;

      // Convert experience_years to integer if it's a string number (only for JSON)
      if (!isFormData) {
        patchData = { ...payload };
        if (patchData.experience_years && typeof patchData.experience_years === 'string') {
          const value = parseInt(patchData.experience_years, 10);
          if (!isNaN(value)) {
            patchData.experience_years = value;
          }
        }
      }

      await axios.patch(
        `/api/v1/phr-app/doctor-static-data/${docId}`,
        patchData,
        { headers }
      );
      toast.success("Doctor information updated successfully !");
      getAllDoctorStatic();
      setTimeout(() => {
        onCloseModal();
      }, 1000);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            window.location.href = "/";
          }, 1000);
        }
      }
    } finally {
      setIsDoctorStaticPatching(false);
    }
  };

  return {
    onPatchDoctorStatic,
    isDoctorStaticPatching,
  };
};

export default usePatchDoctorStatic;

